import { Plus, UserPlus, Flame } from "lucide-react";
import { useNavigate } from "react-router-dom";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { QUICK_CREATE } from "@/config/navigation";
import { useCrmActions } from "@/context/CrmActionsContext";

const ENABLED = { contact: true, lead: true, transaction: true, task: true, event: true, document: true, goal: true, license: true, post: true };

/**
 * Global "+ Create" menu. SELL + RUN + GROW/PROTECT + MARKETING quick actions are live;
 * later-phase actions stay disabled until they ship.
 */
export const QuickCreate = ({ trigger }) => {
  const navigate = useNavigate();
  const { openAddContact, openNewLead, openNewTransaction, openNewTask, openNewEvent, openUploadDocument, openNewGoal, openAddLicense } = useCrmActions();

  const handle = (key) => {
    if (key === "contact") openAddContact();
    if (key === "lead") openNewLead();
    if (key === "transaction") openNewTransaction();
    if (key === "task") openNewTask();
    if (key === "event") openNewEvent();
    if (key === "document") openUploadDocument();
    if (key === "goal") openNewGoal();
    if (key === "license") openAddLicense();
    if (key === "post") navigate("/marketing/studio");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {trigger || (
          <Button className="gap-1.5" data-testid="quick-create-trigger">
            <Plus className="h-4 w-4" />
            <span className="hidden sm:inline">Create</span>
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Create</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {QUICK_CREATE.map(({ key, label, icon: Icon }) => {
          const enabled = ENABLED[key];
          return (
            <DropdownMenuItem
              key={key}
              disabled={!enabled}
              onSelect={() => enabled && handle(key)}
              data-testid={`quick-create-${key}`}
              className="gap-2.5"
            >
              <Icon className={`h-4 w-4 ${enabled ? "text-accent" : "text-muted-foreground"}`} />
              {label}
              {!enabled && <span className="ml-auto text-[10px] uppercase tracking-wider text-muted-foreground">Soon</span>}
            </DropdownMenuItem>
          );
        })}
        <DropdownMenuSeparator />
        <p className="px-2 py-1.5 text-xs text-muted-foreground">
          More creation actions unlock as each module ships.
        </p>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
